// extracted by mini-css-extract-plugin
export default {"HireMePage":"style_HireMePage__DpZ-v"};